export default {
  state: {
    highlightStatics: false
  },

  toggleStaticHighlight() {
    this.state.highlightStatics = !this.state.highlightStatics;
  }
};
